module.exports = __webpack_public_path__ + "static/media/7news.b85defd0.png";